import { Container, Row, Col } from 'design-react-kit';

export default function SiarcFooter({ latestPrivacyFileKey }: { latestPrivacyFileKey: string }) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="it-footer" id="footer">
      {/* py-4 per l'altezza, bg-dark per far risaltare il bianco */}
      <div className="it-footer-small-prints clearfix py-4 bg-dark">
        <Container>
          <Row className="align-items-center">
            
            {/* Sinistra: Informativa Privacy */}
            <Col xs={6} className="text-left">
              {/* <a
                href={`/api/download/documenti-privacy/${latestPrivacyFileKey}`}
                className="font-weight-bold text-white"
                title="Scarica l'informativa privacy"
              >
                Informativa Privacy
              </a> */}
            </Col>
            
            {/* Destra: Copyright bianco e bold */}
            <Col xs={6} className="text-right">
              <p className="mb-0 small text-white font-weight-bold">
                © {currentYear} — SIARC — Tutti i diritti riservati
              </p>
            </Col>

          </Row>
        </Container>
      </div>
    </footer>
  );
}